<template lang="pug">
    div(style="display: flex; flex-direction: column; justify-content: flex-end; align-items: center; flex-wrap: none; width: 68px;")
        div(style="display: flex; flex-direction: row; justify-content: center; width: 68px;")
            v-btn(icon small :color="score === 1 ? 'success' : '#0000008a'" @click="onClickThumbsUp()")
                v-icon(small) mdi-thumb-up

            v-btn(v-if="score === 0" icon small color="error" @click="onClickThumbsDown()")
                v-icon(small) mdi-thumb-down
            v-menu(
                v-else
                v-model="menu"
                :close-on-content-click="false"
                max-width="500"
                min-width="500"
                max-height="200"
                left
                :nudge-bottom="35"
            )
                template(v-slot:activator="{ on, attrs }")
                    v-btn(v-bind="attrs" v-on="on" icon small color="#0000008a")
                        v-icon(small) mdi-thumb-down

                v-card(
                    outlined
                    style="height: auto;"
                )
                    v-textarea.pr-3.pl-3(
                        v-model="notes"
                        label="Feedback"
                        auto-grow
                        clearable
                        :loading="isSaving"
                        rows="1"
                        row-height="15"
                        hint="Please provide feedback to improve Pulse"
                        persistent-hint
                    )

                    v-row
                        v-col(cols='12')
                            .text-right
                                v-btn.ma-2(small outlined ripple @click="menu = false;")
                                    v-icon mdi-window-close
                                    | Cancel

                                v-btn.ma-2.white--text(v-if="validUserFeedback" small :disabled="!validNotes" :loading="isSaving" ripple color="green" @click="onClickThumbsDown()")
                                    v-icon mdi-content-save
                                    | Submit

                                v-btn.ma-2.white--text(v-else small :disabled="!validNotes" :loading="isSaving" ripple color="green" @click="onClickThumbsDown()")
                                    v-icon mdi-content-save
                                    | Submit

        div(style="height: 10px; line-height: 10px; margin-top: -5px;")
            span(style="font-size: 10px; line-height: 10px; color: #0000008a;") Rate Pulse

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data 
    import {
        CreateOrUpdateLlmAssessmentItemUserFeedback,
    } from '@/data';

    export default Vue.extend({
        data() {
            return {
                isSaving: false,
                menu: false,
                notes: null,
                score: null,
            }
        },
        methods: {
            createOrUpdateLlmAssessmentItemUserFeedback() {
                if (!this.validLlmAssessmentItem) {
                    return;
                }

                const options = {
                    notes: this.notes || null,
                    score: this.score || 0,
                }

                this.isSaving = true;
                CreateOrUpdateLlmAssessmentItemUserFeedback(this.llmAssessmentItem?.llm_assessment_item_id || 0, options).then((response) => {
                    if (response?.Data?.llm_assessment_item_user_feedback?.vid?.length > 0) {
                        this.showSnackbar("green", "Successfully submitted feedback");
                    } else {
                        this.showSnackbar("error", "Failed to submit feedback");
                    }

                    this.isSaving = false;
                    this.dialog = false;
                });
            },
            init() {
                if (this.validUserFeedback) {
                    this.score = this.userFeedback.score;
                    this.notes = this.userFeedback.notes;
                }
            },
            onClickThumbsDown() {
                if (this.score === 0) {
                    this.score = null;
                } else {
                    this.score = 0;
                }

                this.menu = false;
                // this.$emit('update-score', this.score);
                this.createOrUpdateLlmAssessmentItemUserFeedback();
            },
            onClickThumbsUp() {
                if (this.score === 1) {
                    this.score = null;
                } else {
                    this.score = 1;
                }

                
                // this.$emit('update-score', this.score);
                this.createOrUpdateLlmAssessmentItemUserFeedback();
            },
        },
        computed: {
            validLlmAssessmentItem() {
                return this.llmAssessmentItem?.llm_assessment_item_id > 0;
            },
            validUserFeedback() {
                return this.userFeedback?.llm_assessment_item_user_feedback_id > 0;
            },
            validNotes() {
                return this.notes?.length > 0;
            },
        },
        props: {
            llmAssessmentItem: Object,
            userFeedback: Object,
            showSnackbar: Function,
        },
        watch: {
            userFeedback: {
                handler() {
                    this.init();
                },
                deep: true,
            }
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>
